<template>
  <div>
    <div v-if="documentPermission || !authApplyPermission">
      <div class="file_search">
        <a-input-search placeholder="按文件 名搜索" style="width: 250px" v-model="fileName" @change="getCompanyFile" />
        <a-button type="primary" @click="loadMaterials">上传</a-button>
      </div>
      <div class="file_content">
        <a-table class="file-table" size="small" :loading="loading" :columns="columns" :dataSource="documentList" :pagination="false" :rowKey="row => row.id">
          <div slot="name" slot-scope="row" @click="clickCheck(row)" style="cursor: pointer; align-items: center" class="flex">
            <file-icon :type="row.fileSuffix" class="icon" />
            {{ row.name }}
            <div v-if="row.isFeishuLink" class="feishu-icon">
              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-icon="LarkLogoColorful">
                <path
                  d="m12.924 12.803.056-.054c.038-.034.076-.072.11-.11l.077-.076.23-.227 1.334-1.319.335-.33c.063-.064.13-.124.195-.184a7.84 7.84 0 0 1 1.271-.943 7.138 7.138 0 0 1 1.096-.533 5.25 5.25 0 0 1 .47-.164 13.177 13.177 0 0 0-2.5-5.013 1.203 1.203 0 0 0-.94-.448h-9.65c-.173 0-.246.224-.107.325a28.23 28.23 0 0 1 8 9.098c.007-.006.016-.012.023-.022Z"
                  fill="#00D6B9"
                ></path>
                <path
                  d="M9.097 21.299a13.258 13.258 0 0 0 11.821-7.247 5.561 5.561 0 0 1-.899 1.259c-.117.12-.237.236-.363.344-.07.06-.142.116-.214.173-.085.066-.174.13-.262.186a5.22 5.22 0 0 1-.354.218 4.624 4.624 0 0 1-.726.331 5.319 5.319 0 0 1-1.883.312 5.888 5.888 0 0 1-.523-.031 6.551 6.551 0 0 1-.729-.126c-.06-.016-.12-.029-.18-.044a22.917 22.917 0 0 1-.495-.14c-.082-.024-.164-.046-.246-.072-.123-.038-.246-.072-.366-.11l-.3-.095-.284-.094-.192-.067c-.08-.025-.155-.053-.234-.082a3.49 3.49 0 0 1-.167-.06c-.11-.04-.22-.079-.328-.12-.063-.025-.126-.047-.19-.072l-.252-.098c-.088-.035-.18-.07-.268-.107l-.173-.07c-.073-.028-.142-.06-.215-.088l-.164-.07c-.057-.024-.114-.05-.17-.075l-.149-.066-.135-.06-.139-.063a90.276 90.276 0 0 1-.322-.149c-.063-.028-.123-.06-.186-.088a5.697 5.697 0 0 1-.199-.098 27.762 27.762 0 0 1-8.067-5.969.18.18 0 0 0-.312.123l.006 9.21c0 .4.2.779.534 1a13.177 13.177 0 0 0 7.325 2.205Z"
                  fill="#3370FF"
                ></path>
                <path
                  d="M23.732 9.295a7.55 7.55 0 0 0-3.35-.776 7.52 7.52 0 0 0-2.06.284l-.224.066c-.054.016-.108.035-.158.05a8.294 8.294 0 0 0-.855.35 7.3 7.3 0 0 0-.552.297 6.699 6.699 0 0 0-.533.347 9.88 9.88 0 0 0-.363.275c-.13.104-.253.211-.376.322-.066.06-.129.123-.195.183l-.335.328-1.337 1.322-.23.227-.076.075c-.038.038-.076.073-.11.11l-.057.055a1.911 1.911 0 0 1-.086.078l-.094.089a13.285 13.285 0 0 1-2.748 1.946 193.508 193.508 0 0 1 .322.148c.044.023.091.042.139.064l.135.06.149.066.17.076.164.069c.072.031.142.06.214.088.057.026.117.048.174.07.088.034.177.072.268.107l.252.098c.063.025.127.047.19.072.11.041.217.082.328.12.057.02.11.041.167.06l.234.082.192.066.284.095.3.095c.123.038.242.075.365.11.083.025.165.047.247.073.164.047.33.094.495.138.06.016.12.032.18.045.113.028.227.05.34.07.13.021.26.04.389.056a5.767 5.767 0 0 0 .994.019 5.05 5.05 0 0 0 .438-.05 5.123 5.123 0 0 0 .975-.25 5.383 5.383 0 0 0 .726-.334c.06-.035.122-.07.182-.108a7.712 7.712 0 0 0 .432-.296c.073-.057.146-.114.215-.174a5.29 5.29 0 0 0 .363-.343 5.222 5.222 0 0 0 .37-.43 5.823 5.823 0 0 0 .527-.827l.128-.258 1.167-2.325-.003.006a7.393 7.393 0 0 1 1.527-2.186Z"
                  fill="#133C9A"
                ></path>
              </svg>
            </div>
          </div>
          <span slot="creator"></span>
          <span slot="sizeDesc" slot-scope="sizeDesc">{{ sizeDesc }}</span>
          <span slot="time" slot-scope="time">{{ time }}</span>
          <span slot="action" slot-scope="row">
            <a-button @click="clickEdit(row)" v-if="row.canOperate" style="margin-right: 5px" size="small">重命名</a-button>
            <a-button @click="clickDownload(row)" v-if="row.canDownload" style="margin-right: 5px" size="small">下载</a-button>
            <a-button @click="clickPermission(row)" v-if="row.canOperate" style="margin-right: 5px" size="small">权限</a-button>
            <a-popconfirm title="确定删除吗?" @confirm="() => onDelete(row)">
              <a-button type="danger" size="small" v-if="row.canOperate">删除</a-button>
            </a-popconfirm>
            <a-button @click="clickTransfer(row)" v-if="row.canTransfer || fileRoundEditPermission" style="margin-left: 5px" size="small">转移</a-button>
          </span>
        </a-table>
        <div class="file_pagination">
          <a-pagination
            size="small"
            showSizeChanger
            :pageSize="pageSize"
            @change="pageChange"
            @showSizeChange="showSizeChange"
            :total="totalNum"
            :current="currentPage"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <documentAuthApply :fileTypeId="fileTypeId" :fileTypeName="fileTypeName"></documentAuthApply>
    </div>
    <!--文档上传-->
    <a-modal
      :width="600"
      :closable="false"
      :maskClosable="false"
      v-if="documentModal && noticeModal === false"
      v-model="documentModal"
      title="文档上传"
      :footer="null"
    >
      <document-upload @close="documentModal = false" @update="updateMenu" :roundValue="roundValue"></document-upload>
    </a-modal>
    <!--文档上传/-->
    <!--文档重命名-->
    <a-modal :width="400" v-model="editModal" title="文档重命名" @ok="handleEdit">
      <a-input placeholder="文件名称" type="small" style="width: 300px" v-model="new_filename" />
    </a-modal>
    <!--文档重命名/-->
    <!--文档转移-->
    <a-modal :width="800" v-model="roundChangeModal" title="文档转移" @ok="roundChange" @cancel="roundChangeClose">
      <div class="file-round-change">
        <div class="file-round-item">
          <div class="change-title">文档名称：</div>
          <div class="change-content">{{ fileRoundInfo.fileName }}</div>
        </div>
        <div class="file-round-item">
          <div class="change-title">文档类型：</div>
          <div class="change-content">{{ fileRoundInfo.fileType }}</div>
        </div>
        <div class="file-round-item">
          <div class="change-title">当前所处轮次：</div>
          <div class="change-content">{{ fileRoundInfo.rounds }}</div>
        </div>
        <div class="file-round-item">
          <div class="change-title"><span class="cannot-empty">*</span>文档轮次变更为：</div>
          <div class="change-content" v-if="fileRoundInfo.isMulSelect">
            <stageMulSelect
              style="width: auto; min-width: 300px"
              :type="1"
              :companyId="this.$route.query.id"
              @input="getEditRound"
              :reFresh="reFresh"
            ></stageMulSelect>
          </div>
          <div class="change-content" v-else>
            <selectItem style="width: 150px" :type="1" :companyId="this.$route.query.id" @input="getEditRound" :reFresh="reFresh"></selectItem>
          </div>
        </div>
        <div class="message-warn" v-if="fileRoundInfo.editRound && fileRoundInfo.editRound !== ''">
          提交后，该文档所属轮次将由{{ fileRoundInfo.rounds }}变更为{{ fileRoundInfo.editRound }}，<span
            v-if="fileRoundInfo.isCurrSecret && fileRoundInfo.isEditSecret"
            >且状态仍为保密中，</span
          >
          <span v-if="fileRoundInfo.isCurrSecret && !fileRoundInfo.isEditSecret">且状态由保密中变为释放，</span>
          <span v-if="!fileRoundInfo.isCurrSecret && fileRoundInfo.isEditSecret">且状态变更为保密中，</span>
          请谨慎操作
        </div>
      </div>
    </a-modal>
    <!--文档转移/-->
    <!--权限设置-->
    <a-modal :width="400" v-model="permissionModal" title="权限设置" @ok="setPermissionUsers" @cancel="tempEdit = ''">
      <a-select :value="authType" style="width: 120px" @change="authChange">
        <a-select-option :value="0">默认</a-select-option>
        <a-select-option :value="1">自定义</a-select-option>
      </a-select>
      <a-spin :spinning="permissionLoad">
        <!-- 默认权限 -->
        <ul class="permission" v-if="authType === 0">
          <li v-for="(item, index) in permission" :key="index">
            <span style="min-width: 80px">{{ item.companyFileTypeDesc }}:</span>
            <select-member
              :width="400"
              :parentIndex="index"
              :userlist="item.users"
              :canDeleteAll="false"
              :canEdit="false"
              :abridged="4"
              :canExpand="true"
            ></select-member>
          </li>
        </ul>
        <!-- 自定义权限 -->
        <ul class="permission" v-if="authType === 1">
          <li v-for="(customItem, index) in customPermission" :key="index">
            <span style="min-width: 80px">{{ customItem.companyFileTypeDesc }}:</span>
            <select-member
              :width="400"
              :parentIndex="index"
              :userlist="customItem.users"
              :canDeleteAll="index != 2 && customItem.users.length > 0 ? true : false"
              :canEdit="index != 2 ? true : false"
              :abridged="authType === 1 && customItem.users.length > 0 ? 3 : 4"
              :canExpand="true"
              @chose="choseUserIds"
              @delChosenUser="delUserIds"
              @delAllUsers="clickDelUser"
            ></select-member>
          </li>
        </ul>
      </a-spin>
    </a-modal>
    <!--权限设置/-->
  </div>
</template>
<script>
import { searchByName, downloadFile as downloadFileApi, roundList } from '@/api/common';
import { companyFileRoundInfo, roundChange } from '@/api/document';
import { downloadFile } from 'assets/js/download';
import { mapGetters } from 'vuex';
import FileIcon from '@/components/base/fileIcon';
import { hasPermission } from '@/utils/utils';
import { MEETING_AUDIO_FILETYPE_ID, SETTLEMENT_INVESRMENT_FILETYPE_ID, SETTLEMENT_EXIT_FILETYPE_ID } from '@/common/constant';
import stageMulSelect from '@/components/base/stageMulSelect.vue';
import infiniteScroll from 'vue-infinite-scroll';
import selectItem from '@/components/base/stageSelect';
import selectMember from '@/components/project/selectMember';
import documentUpload from '@/components/project/documentUpload';
import documentAuthApply from '@/components/document/documentAuthApply';
import {
  getDetail,
  recentUpload,
  getCompanyFile,
  getFileList,
  editFileName,
  deleteFile,
  getPermissionUsers,
  setPermissionUsers,
  getMeeting,
  getVoteList,
  cancelMeeting,
  getNoSummaryList,
  historyStage,
  audioMeetingDetail,
  audioPermission,
  checkFeishuLinkPermission
} from '@/api/project';

export default {
  directives: { infiniteScroll },
  props: {
    projectFileSelectedList: {
      type: Array,
      default: () => []
    },
    stage: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    FileIcon,
    stageMulSelect,
    selectItem,
    selectMember,
    documentUpload,
    documentAuthApply
  },
  watch: {
    projectFileSelectedList() {
      this.currentPage = 1;
      this.getCompanyFile();
    },
    stage(val) {
      this.round = val.round;
      this.phase = val.phase;
      this.getCompanyFile();
    }
  },
  data() {
    return {
      loading: false,
      permissionLoad: false,
      fileName: '',
      new_filename: '',
      companyFileId: '',
      historyStage: [],
      documentList: [],
      editModal: false,
      documentModal: false,
      roundChangeModal: false,
      permissionModal: false,
      annexModal: false,
      noticeModal: false,
      roundListMap: {},
      roundMap: {},
      fileRoundAndPhase: [],
      roundList: [],
      fileRoundInfo: {},
      phaseMap: {
        0: '发展期',
        1: '融资期'
      },

      permission: [], //默认权限
      customPermission: [], //自定义权限

      authType: 0,
      fileRoundEditPermission: false,
      reFresh: true,

      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      documentPermission: true,
      fileTypeId: '',
      authApplyPermission: false,
      fileTypeName: '',
      historyStageMap: {}
    };
  },

  computed: {
    ...mapGetters(['userInfo', 'token']),
    columns() {
      return [
        { title: '文件名', scopedSlots: { customRender: 'name' }, width: 250 },
        {
          title: '上传人',
          customRender: (text, record) => {
            if (record.creator) {
              return record.creator.nickname;
            }
            return '';
          },
          align: 'center',
          width: 50
        },
        {
          title: '文件大小',
          dataIndex: 'sizeDesc',
          align: 'center',
          scopedSlots: { customRender: 'sizeDesc' },
          width: 70
        },
        {
          title: '上传时间',
          dataIndex: 'createAt',
          align: 'center',
          scopedSlots: { customRender: 'time' },
          width: 120
        },
        {
          title: '所属轮次',
          align: 'center',
          customRender: value => {
            let phaseAndRoundList = value.phaseAndRoundMaps;
            let render = '';
            phaseAndRoundList.forEach(_ => {
              render += this.roundListMap[_.round] + '轮' + this.phaseMap[_.phase] + ' ';
            });
            return render;
          },
          width: 200
        },
        {
          title: '操作',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 170
        }
      ];
    }
  },
  mounted() {
    this.initData();
    const { permissions: queue } = this.userInfo || {};
    this.authApplyPermission = hasPermission(queue, '/project/authApply');
  },
  methods: {
    initData() {
      this.getHistoryStage();
      this.getCompanyFile();
      this.getRoundList();
    },
    pageChange(page, pageSize) {
      this.currentPage = page;
      this.pageSize = pageSize;
      this.getCompanyFile();
    },
    showSizeChange(current, size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getCompanyFile();
    },
    //提示框取消
    cancelUpload() {
      this.annexModal = false;
      this.documentModal = false;
      this.noticeModal = false;
    },
    //上传最近文档（上传材料）
    loadMaterials() {
      this.documentModal = true;
    },
    updateMenu() {
      this.getCompanyFile();
      this.$emit('updateMenu');
    },
    async setPermissionUsers() {
      let canViewUserIds = [];
      let canDownloadUserIds = [];
      let canOperateUserIds = [];
      if (this.authType === 0) {
        this.permission.forEach(item => {
          if (item.companyFileTypeId === 0) {
            item.users.forEach(user => {
              canViewUserIds.push(user.id);
            });
          } else if (item.companyFileTypeId === 1) {
            item.users.forEach(user => {
              canDownloadUserIds.push(user.id);
            });
          } else {
            item.users.forEach(user => {
              canOperateUserIds.push(user.id);
            });
          }
        });
      } else {
        this.customPermission.forEach(item => {
          if (item.companyFileTypeId === 0) {
            item.users.forEach(user => {
              canViewUserIds.push(user.id);
            });
          } else if (item.companyFileTypeId === 1) {
            item.users.forEach(user => {
              canDownloadUserIds.push(user.id);
            });
          } else {
            item.users.forEach(user => {
              canOperateUserIds.push(user.id);
            });
          }
        });
      }
      const res = await setPermissionUsers({
        companyFileId: this.companyFileId,
        isDefault: this.authType === 0 ? true : false,
        canViewUserIds: canViewUserIds.join(','),
        canDownloadUserIds: canDownloadUserIds.join(','),
        canOperateUserIds: canOperateUserIds.join(',')
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.permissionModal = false;
        if (this.currentKey === '1') {
          this.recentUpload();
        } else if (this.currentKey === '3') {
          this.getCompanyFile();
        }
      }
    },
    checkEditRound() {
      if (!this.fileRoundAndPhase || this.fileRoundAndPhase.length <= 0) {
        this.$message.error('文档轮次不能为空');
        return false;
      }
      return true;
    },
    authChange(value) {
      this.authType = value;
      if (this.authType === 0) {
        let body = {
          companyFileId: this.companyFileId,
          type: this.authType
        };
        this.getPermissionUsers(body);
      }
    },
    getRoundList() {
      roundList().then(res => {
        if (res.code === 200) {
          this.roundList = res.data;
          this.roundList.forEach(e => {
            this.$set(this.roundListMap, e.id, e.name);
          });
        }
      });
    },
    choseUserIds(users, index) {
      this.$set(this.customPermission, index, {
        companyFileTypeDesc: this.customPermission[index].companyFileTypeDesc,
        companyFileTypeId: this.customPermission[index].companyFileTypeId,
        users: users
      });
    },
    clickDelUser(index) {
      const item = (this.customPermission[index].users = []);
      item.users = [];
    },
    delUserIds(user, index) {
      const item = this.customPermission[index];
      item.users = item.users.filter(_user => _user.id !== user.id);
    },
    getEditRound(val) {
      this.fileRoundAndPhase = val;
      if (val && Array.isArray(val) && val.length > 0) {
        this.$set(this.fileRoundInfo, 'editRound', '');
        let isEditSecret = val.some(_ => _.round === this.fileRoundInfo.raisingRound);
        this.$set(this.fileRoundInfo, 'isEditSecret', isEditSecret);
        val.forEach((_, index) => {
          if (index !== 0) {
            this.fileRoundInfo['editRound'] += '、';
          }
          this.fileRoundInfo['editRound'] += this.roundMap[_.round] + '轮' + this.phaseMap[_.phase];
        });
      } else if (!Array.isArray(val)) {
        this.$set(this.fileRoundInfo, 'isEditSecret', val.round === this.fileRoundInfo.raisingRound ? true : false);
        this.$set(this.fileRoundInfo, 'editRound', this.roundMap[val.round] + '轮' + this.phaseMap[val.phase]);
      } else {
        this.$delete(this.fileRoundInfo, 'isEditSecret');
        this.$delete(this.fileRoundInfo, 'editRound');
      }
    },
    clickEdit(row) {
      this.companyFileId = row.id;
      this.editModal = true;
      this.new_filename = row.name;
    },
    handleEdit() {
      editFileName({
        companyFileId: this.companyFileId,
        name: this.new_filename
      }).then(res => {
        this.getCompanyFile();
        this.editModal = false;
      });
    },
    async getHistoryStage() {
      try {
        let res = await historyStage({ id: this.$route.query.id, type: 1 });
        if (res.code === 200) {
          const { permissions: queue } = this.userInfo || {};
          this.projectRoundEditPermission = hasPermission(queue, '/project/round/edit');
          if (this.historyStage.length > 0) {
            let historyStage = res.data;
            let selectIndex = this.historyStage.findIndex(e => {
              return e.selected === true;
            });
            historyStage.forEach((e, index) => {
              if (index !== selectIndex) {
                e['selected'] = false;
              } else {
                e['selected'] = true;
              }
            });
            this.historyStage = historyStage;
          } else {
            this.historyStage = res.data;
            this.historyStage.forEach(_ => {
              this.roundMap[_.round] = _.roundName;
            });
            this.historyStage.forEach(e => {
              e['selected'] = false;
            });
          }
          this.roundValue = { round: this.historyStage[this.historyStage.length - 1].round, phase: this.historyStage[this.historyStage.length - 1].phase };
          this.selected = this.roundValue;
          this.historyStage.forEach(e => {
            console.log('e', e, this.historyStageMap);
            this.historyStageMap[e.round] = e.roundName;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    onDelete(row) {
      // 如果这个文件是唯一的文件,就把flag置成1
      let flag = 0; // 需要重置页数
      if (this.documentList.length === 1) {
        if (this.currentPage === 1) {
          flag = 1;
        } else {
          this.currentPage = this.currentPage - 1;
        }
      }
      deleteFile(row.id).then(res => {
        this.getCompanyFile();
        this.$emit('updateMenu', flag ? 'reset' : '');
      });
    },

    async clickCheck(row, clickType) {
      console.log('row', row);
      // 是飞书云文档
      if (row.isFeishuLink) {
        try {
          let res = await checkFeishuLinkPermission({
            companyFileId: row.id
          });
          if (res.code === 200) {
            window.open(res.data);
          }
        } catch (e) {
          console.log(e);
        }

        return;
      }
      this.companyFileId = row.id;
      let type = row.fileSuffix;

      // pdf格式预览：docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf
      // image图像格式：jpg,jpeg,png,gif,bmp,ico,raw
      // video视频格式：avi,mov,rmvb,rm,flv,mp4,3gp
      const fileSuffix = [
        { type: 'pdf', strs: 'docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf' },
        { type: 'image', strs: 'jpg,jpeg,png,gif,bmp,ico,raw' },
        { type: 'video', strs: 'avi,mov,rmvb,rm,flv,mp4,3gp' }
      ];

      let temp = fileSuffix.filter(item => item.strs.indexOf(type) > -1);
      if (+row.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
        this.gotoAudio(row, row.meetingType);
        return;
      }
      if (temp.length === 0) {
        type = null;
      } else {
        if (temp[0].type === 'video') {
          type = temp[0].type + '/' + type;
        } else {
          type = temp[0].type;
        }
        if (temp[0].type === 'pdf') {
          localStorage.setItem('download', row.canDownload);
          window.open(window.location.origin + '/pdfview?id=' + row.id + '&projectId=' + this.$route.query.id);
        } else {
          window.open(window.location.origin + '/pdfview?id=' + row.id + '&projectId=' + this.$route.query.id);
        }
      }
    },
    async gotoAudio(item, type) {
      // 调一下接口看有没有权限 / 是飞书妙记还是天池录音
      try {
        let res = await audioPermission({ meetingProjectId: item.meetingProjectId, meetingType: type });
        if (res.code === 200) {
          let url = '';
          if (item.source === 1) {
            // 飞书妙记
            let res2 = await audioMeetingDetail({ meetingProjectId: item.meetingProjectId, meetingType: type });
            url = res2.data.audioIdPath;
          } else {
            // 天池录音
            let routeUrl = this.$router.resolve({
              path: '/project/meetingAudio',
              query: { meetingProjectId: item.meetingProjectId, meetingType: type }
            });
            url = routeUrl.href;
          }
          window.open(url, '_blank');
        } else {
          console.log(e);
          this.$message.error('无查看权限');
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getCompanyFile() {
      this.loading = true;
      let res = await getCompanyFile({
        companyId: +this.$route.query.id,
        name: this.fileName,
        page: this.currentPage,
        pageSize: this.pageSize,
        phase: this.phase,
        roundId: this.round,
        fileTypesStr: JSON.stringify(this.projectFileSelectedList)
      });
      this.loading = false;
      if (res.code === 200) {
        this.$emit('updateData');
        this.documentList = res.data.list || [];
        if (this.projectFileSelectedList.length === 1) {
          // res.data.fileTypes.every
          this.fileTypeId = this.projectFileSelectedList[0].fileTypeId;
          this.fileTypeName = res.data.fileTypes.filter(_ => _.id === this.fileTypeId)[0].name;
          this.documentPermission = res.data.fileTypes.filter(_ => _.id === this.fileTypeId)[0].count !== -1;
        } else {
          this.documentPermission = true;
        }
        this.totalNum = res.data.total;
        let fileTypeCount = res.data.fileTypeCount;
        let fileType = res.data.fileTypes.filter(item => item.status !== -1);
        let total = 0;
        fileType.forEach(item => {
          item.total = fileTypeCount[item.id] ? fileTypeCount[item.id] : 0;
          total += item.total;
        });
        fileType.unshift({ id: '', name: '全部', total: total });
        this.fileType = fileType;
        const userInfo = this.userInfo || {};
        this.documentList.forEach(_ => {
          if (_.creator && _.creator.id === userInfo.id) {
            _.canTransfer = true;
          } else {
            _.canTransfer = false;
          }
          if (['folder', 'file', 'docs', 'doc', 'docx', 'sheet', 'sheets', 'base', 'settings', 'wiki', 'minutes'].includes(_.feishuFileType)) {
            _.isFeishuLink = true;
          } else {
            _.isFeishuLink = false;
          }
        });
        const { permissions: queue } = this.userInfo || {};
        this.fileRoundEditPermission = hasPermission(queue, '/document/round/edit');
      }
    },
    clickDownload(row) {
      this.companyFileId = row.id;
      downloadFileApi({
        fileType: 'projectFile',
        fileId: row.id
      }).then(res => {
        if (res.code === 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFile(downloadPath);
        }
      });
    },
    clickPermission(row) {
      // this.authType = String(row.authType) // 0 默认  1 自定义
      this.customPermission = [];
      this.companyFileId = [row.id];
      this.permissionModal = true;
      let body = {
        companyFileId: this.companyFileId
      };
      this.getPermissionUsers(body);
    },
    async getPermissionUsers(body) {
      this.permissionLoad = true;

      const res = await getPermissionUsers(body);
      this.permissionLoad = false;
      if (res.code === 200) {
        if (!this.customPermission.length) {
          //给this.authType赋值指定当前显示默认还是自定义
          this.authType = res.data.authType;
          this.customPermission = [...res.data.list];
        }
        this.permission = res.data.list;
      }
    },
    async clickTransfer(row) {
      try {
        this.roundChangeModal = true;
        let res = await companyFileRoundInfo({ fileId: row.id });
        if (res.code === 200) {
          this.fileRoundInfo = res.data;
          if (this.fileRoundInfo.currRound && this.fileRoundInfo.currRound.length > 0) {
            this.fileRoundInfo['isCurrSecret'] = this.fileRoundInfo.currRound.some(_ => _.round === this.fileRoundInfo.raisingRound);
            this.fileRoundInfo['rounds'] = '';
            this.fileRoundInfo.currRound.forEach((_, index) => {
              if (index !== 0) {
                this.fileRoundInfo['rounds'] += '、' + _.roundName + '轮' + this.phaseMap[_.phase];
              } else {
                this.fileRoundInfo['rounds'] = _.roundName + '轮' + this.phaseMap[_.phase];
              }
            });
          }
          if (row.fileTypeId === SETTLEMENT_INVESRMENT_FILETYPE_ID || row.fileTypeId === SETTLEMENT_EXIT_FILETYPE_ID) {
            this.fileRoundInfo['isMulSelect'] = true;
          } else {
            this.fileRoundInfo['isMulSelect'] = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async roundChange() {
      if (this.checkEditRound()) {
        try {
          let res = await roundChange({
            fileId: this.fileRoundInfo.fileId,
            fileRoundAndPhase: Array.isArray(this.fileRoundAndPhase) ? this.fileRoundAndPhase : [this.fileRoundAndPhase]
          });
          this.roundChangeClose();
          if (res.code === 200) {
            this.$message.success('保存成功');
            this.getCompanyFile();
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    roundChangeClose() {
      this.roundChangeModal = false;
      this.reFresh = !this.reFresh;
    }
  }
};
</script>
<style lang="less" scoped>
.file-round-change {
  padding: 10px 0px 20px 0px;
  .file-round-item {
    display: flex;
    padding-top: 20px;
    align-items: center;
    .change-title {
      text-align: right;
      font-weight: bold;
      width: 150px;
      .cannot-empty {
        color: @red;
        margin-right: 5px;
      }
    }
    .change-content {
      text-align: left;
      width: 500px;
      margin-left: 10px;
    }
  }
  .message-warn {
    color: @red;
    padding: 30px 0px 0px 50px;
  }
}
.file_search {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
}
.file_content {
  flex: auto;
  .ant-table-wrapper {
    width: 100%;
  }
  .ant-menu-vertical {
    border: none !important;
  }
}
.file_pagination {
  margin: 10px 0;
  text-align: right;
}
.choose_box {
  height: 200px;
  border: 1px solid #e8e8e8;
}
.ant-list,
.ant-list-item-action a {
  font-size: 12px !important;
}
.flex {
  display: flex;
}
</style>
